// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3J2zY","left":"StickyBox_left__230Up","right":"StickyBox_right__3py-x"};